"use client";

import Image from "next/image";
import { motion } from "motion/react";
import styles from "./BrandSplitShell.module.css";

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.4,
    },
  },
};

// Split-screen shell shared by unauthenticated pages (login, unsubscribe):
// brand panel on the left, centered form column on the right.
export const BrandSplitShell: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <div className={styles.shell}>
      <motion.div
        className={styles.background}
        style={{ backgroundImage: "url(/bg.png)" }}
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <Image
          src="/logo.svg"
          alt="Logo"
          width={430}
          height={63}
          className={styles.logo}
          style={{ height: "auto" }}
          priority
        />
      </motion.div>
      <div className={styles.formContainer}>
        <div className={styles.formWrapper}>{children}</div>
      </div>
    </div>
  );
};
